/**
 * reportingTokens.js - the card, palette and axis/tooltip styling shared by
 * every chart on the Reporting tab, so they read as one system.
 */

export const CARD = {
  background: '#fff',
  borderRadius: 8,
  border: '1px solid #E8E8E8',
  padding: 20,
  position: 'relative',
  overflow: 'hidden',
};
export const COLORS = ['#1B5E20', '#1565C0', '#B71C1C', '#6A1B9A', '#E65100', '#00838F', '#F9A825', '#4527A0'];
export const TT = {
  fontFamily: 'Montserrat',
  fontSize: 11,
  borderRadius: 6,
  border: '1px solid #E8E8E8',
  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
};
// Axis ticks were 9px / muted #aaa — too faint at default chart density.
// Bumped to 11px / dark #333 / bolder weight so the X/Y labels actually read.
export const TICK = { fontSize: 11, fill: '#333', fontFamily: 'Montserrat', fontWeight: 700 };
